/* global Word */
import { SearchFnParams } from "@/types/document";
import log from "../../../utils/logger";

/**
 * Searches for a specified text within a given Word range or the entire document body.
 *
 * @param params - The parameters for the search operation, including the Word context, search text, options, paragraph, and fallback behavior.
 * @param range - The Word.Range object to search within. If null, the search is performed in the document body.
 * @returns A promise that resolves to the first matching Word.Range, or null if no match is found.
 */
export const singleSearch = async (params: SearchFnParams, range: Word.Range | null): Promise<Word.Range | null> => {
  try {
    const { context, text: inputText, options, paragraph, fallbackToParagraphWhenTextNotFound } = params;
    const text = inputText || paragraph?.text;
    if (!text) {
      log.error("No text provided for search", "singleSearch", params);
      return fallbackToParagraphWhenTextNotFound ? range : null;
    }
    return (range || context.document.body).search(text, options).getFirstOrNullObject();
  } catch (error) {
    log.error("Error searching document", "singleSearch", error);
    throw error;
  }
};
